import { useTranslation } from 'react-i18next';

import { TurnHighlight } from './buildTurnHighlights';
import { TooltipStepLink } from './DetailsRow';
import { SummaryRow, SummarySection } from './SummaryRows';
import { useGoToDialogNode } from '../../../hooks/useGoToDialogNode';

const DialogLink = ({ nodeId, name }: { nodeId: string; name: string }) => {
  const { t } = useTranslation();
  const link = useGoToDialogNode(nodeId);

  return (
    <TooltipStepLink link={link} tooltip={t('try_it.go_to_dialog')}>
      {name}
    </TooltipStepLink>
  );
};

export const TurnHighlights = ({ highlights }: { highlights: TurnHighlight[] }) => {
  const { t } = useTranslation();

  return (
    <SummarySection title={t('try_it.turn_highlights.title')}>
      {highlights.map((highlight, index) => (
        <SummaryRow key={highlight.key} tone="info" isLast={index === highlights.length - 1}>
          <span>{highlight.text}</span>
          <DialogLink nodeId={highlight.nodeId} name={highlight.dialogName} />
        </SummaryRow>
      ))}
    </SummarySection>
  );
};
